var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"subscription__info"},[_vm._v(" "+_vm._s(_vm.$t('changePlan'))+" "),_c('router-link',{attrs:{"to":_vm.route}},[_vm._v(" "+_vm._s(_vm.$t('changePlanLink'))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }